import styled from 'styled-components'

export const ControlContainer = styled.div`
	display: flex;
	align-items: center;
	pointer-events: none;
	margin: -10px -6px;
	flex-shrink: 0;
`
